module.exports = __webpack_public_path__ + "static/Roc-f660bde1d6de44dc987aba9748f064d3.jpg";